/**
 * Визуальная подпись банка.
 * Коды для API/логики не меняем: ICB остаётся ICB на бэкенде.
 */
export function displayBankName(raw: string | null | undefined): string {
  const s = String(raw ?? '').trim();
  if (!s) return '';
  const u = s.toUpperCase().replace(/\s+/g, '');
  if (u === 'ICB') return 'VIETIN';
  if (u === 'BVBANK' || u === 'VCCB') return 'BV BANK';
  if (u === 'SHB' || u === 'SHBBANK') return 'SHB BANK';
  return s.replace(/\bICB\b/g, 'VIETIN');
}
